module.exports = __webpack_public_path__ + "assets/img/chartCard-detail.f0a16ba7.svg";